export default __webpack_public_path__ + "static/media/image_argentina.376e389f.png";